/**
 * L3 — Telas (“componentes de componentes de componentes”).
 * Cada tela monta formulários L2 + chrome de página; variantes = composições.
 */

const SCREENS = [
  {
    id: 'screen-list',
    nome: 'Tela de listagem',
    paraQue: 'Header + filtros + tabela (e empty quando não há dados).',
    usa: ['form-filters', 'page-header', 'table', 'empty'],
    importName: 'TelaListagem',
    usage: `<TelaListagem
  appearance="filtersBar"
  title="Contratos"
  rows={rows}
  filters={filtros}
  onFiltersChange={setFiltros}
  onNew={abrirNovo}
/>

{/* appearance: "filtersBar" | "filtersChips" | "emptyFirst" */}`,
    variantes: [
      { id: 'A', nome: 'Como no Oikos hoje (Contratos)', mock: 'screenListA' },
      { id: 'B', nome: 'Chips de filtro + tabela', mock: 'screenListB' },
      { id: 'C', nome: 'Empty state em destaque', mock: 'screenListC' },
    ],
  },
  {
    id: 'screen-edit',
    nome: 'Tela de cadastro / edição',
    paraQue: 'Header + formulário wizard (em ordem) + barra de ações.',
    usa: ['page-header', 'form-multisection', 'form-actions', 'form-identity', 'form-address'],
    importName: 'TelaCadastro',
    usage: `<TelaCadastro
  appearance="accordion"
  title="Novo fornecedor"
  value={form}
  onChange={setForm}
  onSave={salvar}
  onCancel={voltar}
/>

{/* appearance: "accordion" | "twoCol" | "wizard" */}`,
    variantes: [
      { id: 'A', nome: 'Accordion + ações', mock: 'screenEditA' },
      { id: 'B', nome: 'Duas colunas + ações', mock: 'screenEditB' },
      { id: 'C', nome: 'Wizard (stepper)', mock: 'screenEditC' },
    ],
  },
  {
    id: 'screen-detail',
    nome: 'Tela de detalhe com abas',
    paraQue: 'Header + tabs de seção; drawer opcional para edição rápida.',
    usa: ['page-header', 'form-multisection', 'drawer', 'status-badge'],
    importName: 'TelaDetalhe',
    usage: `<TelaDetalhe
  appearance="tabs"
  title="Projeto Alpha"
  status="ativo"
  tabs={tabs}
  activeTab={tab}
  onTabChange={setTab}
/>

{/* appearance: "tabs" | "tabsDrawer" | "summarySidebar" */}`,
    variantes: [
      { id: 'A', nome: 'Só abas', mock: 'screenDetailA' },
      { id: 'B', nome: 'Abas + drawer edição', mock: 'screenDetailB' },
      { id: 'C', nome: 'Resumo lateral + abas', mock: 'screenDetailC' },
    ],
  },
  {
    id: 'screen-dashboard',
    nome: 'Tela dashboard',
    paraQue: 'KPIs + gráfico + atalhos de ação.',
    usa: ['kpi', 'chart', 'page-header', 'btn-confirm'],
    importName: 'TelaDashboard',
    usage: `<TelaDashboard
  appearance="kpiRow"
  title="Visão geral"
  kpis={kpis}
  chart={serie}
/>

{/* appearance: "kpiRow" | "kpiGrid" | "chartFocus" */}`,
    variantes: [
      { id: 'A', nome: 'Como no Oikos hoje (KPIs + agenda)', mock: 'screenDashA' },
      { id: 'B', nome: 'Grade de KPIs', mock: 'screenDashB' },
      { id: 'C', nome: 'Gráfico em destaque', mock: 'screenDashC' },
    ],
  },
  {
    id: 'screen-approval',
    nome: 'Fila de aprovação',
    paraQue: 'Lista de pendências + card de decisão.',
    usa: ['form-approval', 'table', 'filter', 'status-badge'],
    importName: 'TelaFilaAprovacao',
    usage: `<TelaFilaAprovacao
  appearance="split"
  items={fila}
  selectedId={id}
  onSelect={setId}
  onApprove={aprovar}
  onReject={rejeitar}
/>

{/* appearance: "split" | "listOnly" | "cardStack" */}`,
    variantes: [
      { id: 'A', nome: 'Lista + card ao lado', mock: 'screenApprovalA' },
      { id: 'B', nome: 'Só lista com ações', mock: 'screenApprovalB' },
      { id: 'C', nome: 'Stack de cards', mock: 'screenApprovalC' },
    ],
  },
]

export default SCREENS
